<template>

  <ProductFormProductionEmbeddable
      @mounted="onMountedForm"
      @beforeSubmit="onBeforeSubmit"
      @reload="reload()"
      ref="embeddable"
      v-model="form"
      v-if="!mountAgain && pageEmbeddableLoaded && accountModule === 'production'"
      :enabled-submit="enabledSubmit"
  />

  <ProductFormArchEmbeddable
      @mounted="onMountedForm"
      @beforeSubmit="onBeforeSubmit"
      @reload="reload()"
      ref="embeddable"
      v-model="form"
      v-else-if="!mountAgain && pageEmbeddableLoaded && accountModule === 'arch'"
      :enabled-submit="enabledSubmit"
  />

</template>
<script>
import productFormEmbeddableMixin from "@/mixins/embeddable/product/productFormEmbeddableMixin";
import ui from "@/assets/scripts/ui";

export default {
  name: 'ProductForm',
  mixins: [productFormEmbeddableMixin],
  data() {
    return {

      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela
      accountModule: "",
      //--------------------------------------------------------------------------------------
    }
  },
  methods: {

    mountedPrepare() {
      this.accountModule = ui.getAccountModule()
    },
    async mountedContinued() {

      this.pageEmbeddableLoaded = true

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela
    onBeforeSubmit() {

      //Libera a continuidade sem nenhuma condição especial
      this.enabledSubmit = true
    }
    //--------------------------------------------------------------------------------------

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedContinued()

  },
}
</script>
